import React from "react";
import Subscribe from "../sharedPages/copyTradeCm/Subscribe.js";

const SubscriptionAndBilling = ({ setCommunity }) => {
  return (
    <div className="container subscriptionBillingPage">
      <div className="row justify-content-center h-100">
        <div className="">
          <Subscribe setCommunity={setCommunity} />
        </div>
      </div>
    </div>
  );
};
// row justify-content-center support_wrapper
// style={{ width: "1069.5px" }}
export default SubscriptionAndBilling;
